module.exports = __webpack_public_path__ + "img/ic_item_fk_click.dd16c2db.png";